module.exports = __webpack_public_path__ + "static/nest-840ff6c53a9a60ed9bd408b18f869ea1.svg";